import { ReactNode } from "react"

import Pill from "./Pill"

export type PillTone = "default" | "info" | "success" | "warning" | "error"

export type PillSize = "sm" | "md"

export interface Props {
  ariaLabel?: string
  className?: string
  icon?: ReactNode
  label: string
  onClick?: () => void
  size?: PillSize
  tone?: PillTone
}

export interface ComponentProps extends Props {}

export default Pill
